import { Tooltip } from 'primereact/tooltip';
import { LuFileEdit } from 'react-icons/lu';

import { RadioButtonComponent } from '../../../../components/RadioButtonComponent';
import { validatePermissions } from '../../../../utils/utils';
import { AccessListValues, PermitsList } from '../../../../permitsList';

export const statusCheckbox: any = (rowData: any, columnData: any) => {
  let field = rowData[columnData['field']];
  let color = 'bg-black';
  switch (field) {
    case 'Activar':
      color = 'bg-official_green';
      break;
    case 'Emitir':
      color = 'bg-dark_blue';
      break;
    case 'Inactivar':
      color = 'bg-ligth_grey';
      break;
    case 'Dañado':
      color = 'bg-red';
      break;
    case 'Inicializar':
      color = 'bg-ligth_blue';
      break;

    default:
      break;
  }
  return <div className={`h-5 w-5 rounded-2xl ${color}`}></div>;
};

export const checkBody: any = (rowData: any, columnData: any) => {
  return (
    <RadioButtonComponent
      inputId={rowData.sam_id}
      name={rowData.sam_id}
      checked={rowData[columnData['field']]}
    />
  );
};

export const getActionsTemplate = (reassignHandler: any) => {
  const actionsInventory = (row: any) => {
    return validatePermissions(PermitsList.OP_REASSIGN_SAM, true) ? (
      <div className="flex w-full justify-around text-xl gap-3">
        <Tooltip target=".custom-target-icon" />
        <div>
          <LuFileEdit
            className="cursor-pointer custom-target-icon"
            data-pr-tooltip={'Reasignar'}
            data-pr-position="top"
            onClick={() => {
              reassignHandler(row);
            }}
          />
        </div>
      </div>
    ) : null;
  };
  return actionsInventory;
};
